interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

interface FeaturesProps {
  features: FeatureItem[];
}

export default function Features({ features }: FeaturesProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 font-heading mb-4">
            为什么选择 17.c
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大核心优势，为您提供值得信赖的专业服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-primary-600`} />
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}